module.exports = __webpack_public_path__ + "static/ruscitto-bc-blue-5b6ae63c5330f36222271600595d435f.png";